import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  CardActionArea,
  Paper
} from '@mui/material';
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import AssessmentIcon from '@mui/icons-material/Assessment';
import { useLanguage } from '../context/LanguageContext';

const MemberManagement = () => {
  const navigate = useNavigate();
  const { lang } = useLanguage();

  const sections = [
    {
      path: '/member-registration',
      icon: PersonAddAlt1Icon,
      title: {
        telugu: 'సభ్యుల నమోదు',
        sanskrit: 'सदस्य पञ्जीकरणम्'
      },
      description: {
        telugu: 'కొత్త సభ్యులను నమోదు చేయండి',
        sanskrit: 'नूतनसदस्यानां पञ्जीकरणं करोतु'
      },
      color: '#1976d2'
    },
    {
      path: '/registrations-view',
      icon: AssessmentIcon,
      title: {
        telugu: 'సభ్యుల నమోదు నివేదిక',
        sanskrit: 'सदस्य पञ्जीकरण నివేదిక'
      },
      description: {
        telugu: 'నమోదైన సభ్యుల వివరాలను చూడండి',
        sanskrit: 'पञ्जीकृतसदस्यानां विवरणानि पశ్యతు'
      },
      color: '#2e7d32'
    }
  ];

  return (
    <Container maxWidth="lg">
      <Paper 
        elevation={0} 
        sx={{ 
          p: 4, 
          mb: 4, 
          background: 'linear-gradient(135deg, #7f4b2d 0%, #d0b996 100%)',
          borderRadius: 5
        }}
      >
        <Typography 
          variant="h4" 
          sx={{ 
            color: '#fff', 
            fontWeight: 700,
            textAlign: 'center',
            mb: 1
          }}
        >
          {lang === 'telugu' ? 'సభ్యుల నమోదు విభాగం' : 'सदस्य पञ्जीकरण विभागः'}
        </Typography>
        <Typography 
          variant="body1" 
          sx={{ 
            color: 'rgba(255,255,255,0.9)', 
            textAlign: 'center'
          }}
        >
          {lang === 'telugu' 
            ? 'సభ్యుల నిర్వహణ మరియు నివేదికల కోసం కింది విభాగాలను ఎంచుకోండి' 
            : 'सदस्यप्रबन्धनार्थं నివేదకానాం చ అధః విభాగన్ చినోతు'}
        </Typography>
      </Paper>

      <Grid container spacing={3}>
        {sections.map((section, index) => (
          <Grid item xs={12} sm={6} key={index}>
            <Card
              elevation={3}
              sx={{
                height: '100%',
                transition: 'all 0.3s ease',
                '&:hover': {
                  transform: 'translateY(-8px)',
                  boxShadow: 6
                }
              }}
            >
              <CardActionArea
                onClick={() => navigate(section.path)}
                sx={{ height: '100%', p: 3 }}
              >
                <CardContent sx={{ textAlign: 'center' }}>
                  <Box
                    sx={{
                      backgroundColor: section.color,
                      borderRadius: '50%',
                      p: 2,
                      mb: 2,
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                  >
                    <section.icon sx={{ fontSize: 48, color: '#fff' }} />
                  </Box>
                  <Typography
                    variant="h5"
                    sx={{
                      fontWeight: 600,
                      color: section.color,
                      mb: 1
                    }}
                  >
                    {section.title[lang]}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {section.description[lang]}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default MemberManagement;